import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';
import HashLink from './HashLink';
import brand from '../../config/brand';
import PoweredByCompass from '../PoweredByCompass';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer section fade-in-up">
      <div className="container footer-grid">
        <div className="footer-brand">
          <img src="/images/logo.png" className="hero-logo" alt={`${brand.conference.name} Logo`} />
          <p>©2026 {brand.conference.name}</p>
        </div>
        <div className="footer-links">
          <ul>
            <li><Link to="/travel/info">Travel Information</Link></li>
            <li><Link to="/travel/accommodation">Hotel</Link></li>
            <li><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/visitor-600/tourist-stream-overseas" target="_blank" rel="noopener noreferrer">Visa</a></li>
            <li><a href="https://jp.translink.com.au/plan-your-journey/journey-planner?endLocationId=PL%3AChIJZSd0aAlakWsR4w6XMpW5tVM&end=Brisbane+Convention+%26+Exhibition+Centre%3B+Merivale+Street%2C+South+Brisbane+QLD&timeSearchMode=LeaveAfter&maximumWalkingDistance=4000&walkingSpeed=Normal&fareTypes=Free&fareTypes=Prepaid&fareTypes=Standard&serviceTypes=Express&serviceTypes=NightLink&serviceTypes=Regular&serviceTypes=School&transportModes=Bus&transportModes=Ferry&transportModes=Train&transportModes=Tram" target="_blank" rel="noopener noreferrer">Transportation</a></li>
            <li><Link to="/venue">Conference Venue</Link></li>
            <li><HashLink to="/#organizers">Host Organization</HashLink></li>
          </ul>
        </div>
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p>Email: <a href="mailto:ices2026@uq.edu.au">ices2026@uq.edu.au</a></p>
          <h4 className="footer-follow-heading">Follow Us</h4>
          <a
            href="https://www.linkedin.com/company/ices2026/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link"
            aria-label="ICES2026 on LinkedIn"
          >
            <FaLinkedin className="footer-linkedin-icon" />
            <span>LinkedIn</span>
          </a>
        </div>
      </div>
      <PoweredByCompass style={{ marginTop: 24 }} />
    </footer>
  );
};

export default Footer;
